import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import SelectInput from '../../../components/fields/SelectInput/SelectInput';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { updateUser } from '../../Clients/actions';
import { vehicleTypeOptions } from '../../Clients/constants';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { loadSessionId } from '../actions';
import { getResponseError } from '../../../utils/utils';

const inferLpnTypeByValue = (value, fallbackType = 'ru') => {
  const normalized = String(value || '').trim().toUpperCase().replace(/[\s-]+/g, '');
  if (!normalized) {
    return null;
  }

  if (/^\d{2}[A-Z]{2}\d{3}$/.test(normalized)) {
    return 'am';
  }

  if (/^[ABEKMHOPCTYXАВЕКМНОРСТУХ]\d{3}[ABEKMHOPCTYXАВЕКМНОРСТУХ]{2}\d{2,3}$/.test(normalized)) {
    return 'ru';
  }

  return fallbackType;
};

export default function SessionClientEditModal(props) {
  const {
    showClientEditModal = false,
    setShowClientEditModal = () => {},
    client = {},
    sessionId,
  } = props;

  const dispatch = useDispatch();
  const {
    control,
    getValues,
    reset,
  } = useForm({
    defaultValues: {
      lpn: client?.lpn || '',
      vehicle_type: client?.vehicle_type || 'car',
    },
  });

  useEffect(() => {
    reset({
      lpn: client?.lpn || '',
      vehicle_type: client?.vehicle_type || 'car',
    });
  }, [client, reset, showClientEditModal]);

  const closeModal = () => {
    setShowClientEditModal(false);
  };

  const handleSaveClient = event => {
    const clientId = client?.id;
    if (!clientId) {
      return;
    }

    const formData = getValues();
    const payload = {};

    if (formData.vehicle_type) {
      payload.vehicle_type = formData.vehicle_type;
    }

    const lpnValue = String(formData.lpn || '').trim();
    if (lpnValue) {
      payload.lpn = lpnValue;
      payload.lpn_type = inferLpnTypeByValue(lpnValue, client?.lpn_type || 'ru');
    }

    dispatch(updateUser({ id: clientId, userData: payload }))
      .then(() => {
        successNotification('Редактирование клиента', 'Карточка клиента обновлена');
        if (sessionId) {
          dispatch(loadSessionId({ id: sessionId })).catch(() => {});
        }
        closeModal();
      })
      .catch(response => {
        errorNotification('Редактирование клиента', getResponseError(response));
      });

    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Dialog
      className={classNames('slp-close-modal', 'slp-client-edit-modal')}
      size="xl"
      onClose={closeModal}
      open={showClientEditModal}
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            <div className="hff-title-text f2">Редактирование карточки клиента {client?.id || ''} (ИД)</div>
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={closeModal} />
            </div>
          </>
        )}
      />
      <DialogContent className="hff-content">
        <FieldDTO
          control={control}
          type="text"
          component={TextInputWithLabel}
          withLabel
          dtoObject={{
            name: 'lpn',
            type: String,
            validators: [],
            labelKey: 'client.lpn',
          }}
          variant="material"
        />
        <FieldDTO
          control={control}
          type="text"
          dtoObject={{
            name: 'vehicle_type',
            type: String,
            validators: [],
            labelKey: 'client.vehicle_type',
          }}
          withLabel
          addPlaceholder
          component={SelectInput}
          options={vehicleTypeOptions}
          variant="material"
        />
      </DialogContent>
      <DialogFooter>
        <Button variant="secondary" onClick={closeModal}>Отмена</Button>
        <Button onClick={handleSaveClient}>Сохранить</Button>
      </DialogFooter>
    </Dialog>
  );
}
